{
  "general": {
    "title": "Titel"
  },
  "header": {
    "language": "Taal",
    "help": "Help",
    "help_modal": {
      "description": "Als u hulp nodig heeft of vragen heeft, kunt u contact met ons opnemen via e-mail op {mail} of telefonisch op {phone}."
    }
  },
  "fields": {
    "error_message": "Dit veld is verplicht",
    "invalid_email": "Ongeldig e-mailadres",
    "invalid_end": "Eindtijd moet na de starttijd liggen",
    "terms_required": "U moet akkoord gaan met de algemene voorwaarden om door te gaan",
    "invalid_phone": "Ongeldig telefoonnummer. Probeer de landcode toe te voegen."
  },
  "reservation_steps": {
    "title": "Uw boeking:",
    "step_1": {
      "title": "Boekingsgegevens",
      "sub_steps": {
        "services": "Benodigde diensten",
        "location": "Kies een locatie",
        "email": "Contactgegevens"
      }
    },
    "step_2": {
      "title": "Evenementruimtes",
      "sub_steps": {
        "basic_information_meeting_rooms": "Uw evenement",
        "days": "Evenementdetails",
        "remarks": "Opmerkingen"
      }
    },
    "step_3": {
      "title": "Gastenkamers",
      "title_with_date": "Gastenkamers voor {date}",
      "sub_steps": {
        "basic_information_hotel_rooms": "Details"
      }
    },
    "step_4": {
      "title": "Contactgegevens",
      "sub_steps": {
        "basic_information": "Accountgegevens",
        "contact_person": "Factuuradres"
      }
    },
    "step_5": {
      "title": "Boekingsoverzicht"
    }
  },
  "reservation_form": {
    "step_1": {
      "services": {
        "title": "Benodigde diensten",
        "mice": "Evenementruimtes",
        "hotel": "Gastenkamers"
      },
      "location": {
        "title": "Kies een locatie",
        "address": "Adres",
        "phonenumber": "Telefoonnummer"
      },
      "contract_email": {
        "title": "Contactgegevens",
        "field": "E-mailadres"
      }
    },
    "step_2": {
      "basic_information": {
        "title": "Uw evenement",
        "description_header": "",
        "description": "Selecteer de dagen waarop uw evenement plaatsvindt. U kunt meerdere dagen selecteren en de details per dag aanpassen.",
        "fields": {
          "event_name": "Naam van het evenement",
          "event_type": "Type evenement",
          "number_of_guests": "Aantal gasten",
          "start_time": "Starttijd",
          "end_time": "Eindtijd",
          "amount": "Bedrag",
          "total": "Totaal",
          "add": "Toevoegen",
          "emplacement": "Opstelling"
        }
      },
      "add_day": {
        "title": "Wilt u nog een dag toevoegen?",
        "add_day": "Dag toevoegen",
        "add_item": "Product toevoegen",
        "day": "Dag {dayCount}",
        "date": "Datum",
        "select_date": "Selecteer datum",
        "select_date_description": "Dit is {day} van uw evenement. U kunt de details voor deze dag hieronder aanpassen.",
        "plenary_hall": "Functieruimte",
        "sub_hall": "Subruimte",
        "add_hall_description": "Klik op de knop 'Functieruimte toevoegen' om meer ruimtes aan deze dag toe te voegen.",
        "add_hall_required": "Aangezien uw pakket geen functieruimte bevat, moet u er minimaal één toevoegen",
        "add_hall_required_error": "Voeg minimaal één functieruimte toe om door te gaan",
        "add_hall_button": "Functieruimte toevoegen",
        "package_deal": "Beschikbare arrangementen",
        "package_deal_chosen": "Geselecteerd arrangement",
        "package_deal_available": "Beschikbare arrangementen",
        "package_deal_items": "Extra producten",
        "package_deal_items_included": "Bekijk inbegrepen producten",
        "package_deal_spaces_included": "Inbegrepen functieruimtes",
        "additional_items": "Extra producten",
        "search": "Zoeken",
        "no_items_found": "Geen producten gevonden",
        "choose_package_deal": "Kiezen",
        "deselect_package_deal": "Verwijderen"
      },
      "remarks": {
        "title": "Opmerkingen"
      },
      "item_types": {
        "audiovisual": "Audiovisueel",
        "food_beverage": "Eten & drinken",
        "other": "Overig"
      },
      "item_examples": {
        "audiovisual": "Bijvoorbeeld: microfoons",
        "food_beverage": "Bijvoorbeeld: snacks",
        "other": "Bijvoorbeeld: bloemen"
      },
      "clone_day": "Dag kopiëren",
      "space_selector": {
        "show_spaces": "Kies een functieruimte",
        "hide_spaces": "Verberg functieruimtes",
        "no_selection": "Wij kiezen op basis van de bovenstaande informatie een geschikte functieruimte voor u.",
        "capacities": "Capaciteit per opstelling",
        "space_not_available": "Niet beschikbaar",
        "space_selected": "Geselecteerd",
        "select_space": "Selecteren",
        "show_more": "Toon meer ruimtes",
        "show_less": "Toon minder ruimtes",
        "show_unavailable": "Toon niet-beschikbare ruimtes",
        "hide_unavailable": "Verberg niet-beschikbare ruimtes",
        "no_image": "Geen foto beschikbaar"
      }
    },
    "step_3": {
      "booking": {
        "title": "Gastenkamers",
        "title_with_date": "Gastenkamers voor {date}",
        "available": "Beschikbaar",
        "unavailable": "Niet beschikbaar",
        "fields": {
          "name": "Groepsnaam",
          "check_in_date": "Check-in",
          "check_out_date": "Check-out",
          "property": "Locatie voor Hotelkamers",
          "number_of_rooms": "Aantal kamers",
          "persons_per_room": "Gasten/kamer",
          "total_guests": "Totaal aantal gasten",
          "room_type": "Kamertype",
          "late_check_out": "Late check-out",
          "late_check_out_rooms": "Kamers met late check-out",
          "breakfast": "Ontbijt",
          "remarks": "Opmerkingen"
        }
      },
      "overnight_stay": {
        "title": "Wilt u nog een extra overnachting?",
        "button": "Overnachting toevoegen",
        "day": "Overnachting"
      },
      "clone_room": "Overnachting kopiëren"
    },
    "step_4": {
      "account_details": {
        "title": "Accountgegevens",
        "fields": {
          "first_name": "Voornaam",
          "last_name": "Achternaam",
          "company_name": "Bedrijf",
          "email_address": "E-mailadres",
          "phone_number": "Telefoonnummer"
        }
      },
      "billing_address": {
        "title": "Factuuradres",
        "fields": {
          "address": "Adres",
          "postal_code": "Postcode",
          "city": "Plaats",
          "country": "Land"
        }
      },
      "contact_person_location": {
        "title": "Contactpersoon op locatie",
        "fields": {
          "copy": "Kopieer van accountgegevens"
        }
      },
      "discount_code": "Actiecode",
      "invoice_reference": "Factuurreferentie"
    },
    "step_5": {
      "offer": "Uw offerte",
      "reservation": "Uw reservering",
      "request": "Uw boeking",
      "offer_details": "U kunt hier alle details bekijken. Bekijk ook de suggesties die wij op basis van onze expertise voor u hebben geselecteerd.",
      "download_pdf": "PDF downloaden",
      "hotel_only_meeting": "stay",
      "discount": "Korting",
      "remarks": "Opmerkingen",
      "payment_method": "Betaalmethode",
      "payment_done": "Betaling geslaagd",
      "payment_succeeded": "Uw boeking is geplaatst. Wij sturen u een e-mail met uw gegevens.",
      "payment_waiting": "Betaling in behandeling",
      "payment_processing": "Uw betaling wordt nog verwerkt. Wij sturen u een e-mail zodra uw betaling geslaagd is.",
      "payment_failed": "Betaling mislukt",
      "payment_failed_message": "Er is iets misgegaan bij het verwerken van uw betaling. Probeer het alstublieft opnieuw.",
      "sub_total_exclusive_vat": "Subtotaal (exclusief btw)",
      "sub_total_exclusive_sales_tax": "Subtotaal (exclusief verkoopbelasting)",
      "vat_amount": "{vat}% btw",
      "sales_tax_amount": "{vat}% verkoopbelasting",
      "terms_and_conditions": "Algemene voorwaarden",
      "minutes_left": "Uw aanvraag wordt nog 1 minuut voor u gereserveerd. Rond uw betaling snel af om deze te bevestigen. | Uw aanvraag wordt nog <strong>{count} minuten</strong> voor u gereserveerd. Rond uw betaling snel af om deze te bevestigen.",
      "seconds_left": "U heeft nog <strong>1 seconde</strong> om uw betaling af te ronden. Uw aanvraag verloopt spoedig. | U heeft nog <strong>{count} seconden</strong> om uw betaling af te ronden. Uw aanvraag verloopt spoedig.",
      "timer": {
        "title": "Tijd op",
        "subtitle": "Sorry, de tijd voor het afronden van uw betaling is verstreken. Maak u geen zorgen, uw aanvraag is bewaard en wij nemen zo snel mogelijk contact met u op."
      },
      "basic_information": {
        "title": "Boekingsdetails",
        "event_name": "Naam van het evenement",
        "event_type": "Type evenement"
      },
      "contact_information": {
        "title": "Contactinformatie",
        "contact_person_location": "Contactpersoon op locatie",
        "account_details": "Accountgegevens",
        "billing_address": "Factuuradres"
      },
      "day": {
        "day": "Dag {dayCount}",
        "function_spaces": "Functieruimtes",
        "additional_function_spaces": "Aanvullende functieruimtes",
        "pax": "Aantal gasten",
        "emplacement": "Opstelling",
        "start_time": "Starttijd",
        "end_time": "Eindtijd",
        "package_deals": "Arrangementen",
        "package_deals_details": "Het arrangement dat voor u gereedstaat met de bijbehorende producten.",
        "package_deals_amount": "1 arrangement | {count} arrangementen",
        "package_deals_price": "{amount} per person",
        "additional_items": "Extra producten",
        "total": "Totaal",
        "vat": "inclusief btw",
        "sales_tax": "exclusief verkoopbelasting",
        "hall_rental": {
          "title": "Huur van functieruimte",
          "pax": "{pax} Personen"
        }
      },
      "hotel_room": {
        "title": "Gastenkamers",
        "price": "Prijs",
        "room_type": "Kamertype",
        "rooms": "Kamers",
        "number_of_rooms": "0 Kamers | 1 Kamer | {n} Kamers",
        "per_room": "Bezetting",
        "pax_room": "0 Personen per kamer | 1 Persoon per kamer | {n} Personen per kamer",
        "breakfast": "Ontbijt",
        "breakfast_included": "Niet inbegrepen | Inbegrepen",
        "late_checkout": "Late check-out",
        "nights": "0 nachten | 1 nacht | {n} nachten",
        "per_night": "{amount} per kamer per nacht",
        "breakfast_price": "{name}: {amount} per persoon per nacht",
        "late_checkout_price": "Late check-out: {amount} per kamer",
        "city_tax": "Exclusief toeristenbelasting"
      },
      "multi_venue_alert": {
        "title": "Boeking op verschillende locaties",
        "description": "Gastenkamers zijn geboekt op andere locaties. Zie details hieronder."
      }
    },
    "modal": {
      "confirm_turn_down": {
        "title": "Weet u zeker dat u deze offerte wilt afwijzen?",
        "body": "Dit kan niet ongedaan gemaakt worden.",
        "checkbox": "Ik accepteer dat ik deze offerte onherroepelijk afwijs."
      },
      "confirm_cancel": {
        "title": "Weet u zeker dat u deze reservatie wilt annuleren?",
        "body": "De algemene voorwaarden zijn van toepassing.",
        "checkbox": "Ik heb de <a href='{termsUrl}' target='_blank'>algemene voorwaarden</a> gelezen, begrepen en ga ermee akkoord."
      },
      "confirm_accept": {
        "title": "Bevestig uw reservatie",
        "body": "De algemene voorwaarden zijn van toepassing.",
        "checkbox": "Ik heb de <a href='{termsUrl}' target='_blank'>algemene voorwaarden</a> gelezen, begrepen en ga ermee akkoord."
      },
      "reservation_edited": {
        "title": "Hartelijk dank. Uw wijzigingen zijn doorgevoerd."
      },
      "reservation_submitted": {
        "title": "Hartelijk dank. Het is geweldig om uw interesse te zien in het organiseren van uw {meeting} bij ons.",
        "body": "U ontvangt zo spoedig mogelijk een offerte voor uw boeking.",
        "button": "Klik hier om de website van {locationName} te bezoeken"
      },
      "reservation_accepted": {
        "body": "U ontvangt zo spoedig mogelijk een bevestiging van uw boeking."
      },
      "reservation_cancelled": {
        "title": "U heeft de reservatie voor uw {meeting} geannuleerd."
      },
      "reservation_turned_down": {
        "title": "U heeft de offerte voor uw {meeting} afgewezen."
      },
      "cancel_reason": {
        "text": "Reden voor annulering",
        "placeholder": "Geef alstublieft aan waarom u deze reservatie annuleert."
      },
      "turn_down_reason": {
        "text": "Reden voor afwijzing",
        "placeholder": "Geef alstublieft aan waarom u deze offerte afwijst."
      },
      "submitting": {
        "title": "Wij verwerken uw aanvraag",
        "subtitle": "Dit kan even duren. Sluit dit venster alstublieft niet."
      },
      "request": {
        "loading_title": "Wij maken uw optionele boeking aan.",
        "submitted_text": "U ontvangt zo spoedig mogelijk een offerte voor uw boeking."
      },
      "inquire": {
        "loading_title": "Wij maken uw aanvraag aan.",
        "submitted_text": "Wij nemen zo spoedig mogelijk contact met u op."
      },
      "book": {
        "loading_title": "Wij berekenen de prijs.",
        "submitted_text": ""
      }
    },
    "buttons": {
      "edit_reservation": "Reservering Bewerken",
      "save_pdf": "Sla op als PDF",
      "submit_offer": "Offerte Aanvragen",
      "next_step": "Volgende Stap",
      "previous_step": "Vorige Stap",
      "accept_offer": "Offerte Accepteren",
      "cancel_offer": "Reservering Annuleren",
      "turn_down_offer": "Offerte Afwijzen",
      "edit_offer": "Wijzigingen Doorvoeren",
      "request_proposal": "Voorstel Aanvragen",
      "request": "Voorstel Aanvragen",
      "inquire": "Informatie Opvragen",
      "book": "Nu Boeken",
      "accept_booking": "Boeking Bevestigen",
      "pay_booking": "Betalen",
      "cancel_booking": "Boeking Annuleren"
    }
  },
  "dropdown": {
    "no_results": "Geen resultaten gevonden",
    "placeholder": "Optie selecteren",
    "loading": "Laden..."
  },
  "switch": {
    "yes": "Ja",
    "no": "Nee"
  },
  "enums": {
    "payment_method": {
      "AT_LOCATION": "Ter Plaatse",
      "CREDIT_CARD": "Creditcard",
      "INVOICE": "Factuur",
      "PRE_PAYMENT": "Vooruitbetaling",
      "VOUCHER": "Voucher"
    }
  }
}
